import { useEffect, useState } from 'react';
import Clarity from '@microsoft/clarity';

const useClarity = () => {
  const [projectId, setProjectId] = useState<string | null>(null);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const isInIframe = window.self !== window.top;

    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === 'CLARITY_PROJECT_ID' && event.data?.projectId) {
        setProjectId(event.data.projectId);
      }
    };

    if (isInIframe) {
      window.addEventListener('message', handleMessage);
      window.parent.postMessage({ type: 'REQUEST_CLARITY_PROJECT_ID' }, '*');
    }

    return () => {
      if (isInIframe) {
        window.removeEventListener('message', handleMessage);
      }
    };
  }, []);

  useEffect(() => {
    if (projectId && !isInitialized) {
      Clarity.init(projectId);
      setIsInitialized(true);
    }
  }, [projectId, isInitialized]);

  // Fallback: immediate for standalone, delayed for iframe
  useEffect(() => {
    const isInIframe = window.self !== window.top;

    const timeout = setTimeout(
      () => {
        if (!isInitialized) {
          const envProjectId = process.env.REACT_APP_CLARITY_PROJECT_ID;
          if (envProjectId) {
            Clarity.init(envProjectId);
            setIsInitialized(true);
          }
        }
      },
      isInIframe ? 2000 : 0
    );

    return () => clearTimeout(timeout);
  }, [isInitialized]);
};

export default useClarity;
export { Clarity };
